import * as types from './action-types';

export const initialState = {
  list: [],
  fetchStatus: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CURRENCIES:
      return {...state, list: action.payload, error: null};
    case types.FETCH_CURRENCIES:
      return {...state, fetchStatus: 'fetching'};
    case types.FETCH_CURRENCIES_SUCCESS:
      return {...state, fetchStatus: 'success', error: null};
    case types.FETCH_CURRENCIES_FAIL:
      return {...state, fetchStatus: 'fail'};
    case types.ERROR_CURRENCIES:
      return {...state, error: action.payload};
  }

  return state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/currencies/reducer.js
 **/